export const screenPath = '/ReactMyAccountDevices/';
export const screenPathDevice = '/ReactMyAccountDevices/Devices/';
export const screenPathDeviceDetailing =
  '/ReactMyAccountDevices/DeviceDetails/';

export const controlDetailManageDeviceSubscription =
  'UMA Subscriptions Details Page';
